import React from "react";
import FeaturedTopics from "../components/FeaturedTopics/FeaturedTopics";


const FeaturedTopicsContainer = () => {
  return (
    <FeaturedTopics />
  );
};

export default FeaturedTopicsContainer;
